const toFiniteNumber = (value) => {
  const number = Number(value)
  return Number.isFinite(number) ? number : null
}

export const getSpentAmount = (balance = {}) => {
  const safeBalance = balance || {}

  const spent = toFiniteNumber(safeBalance.spent)
  if (spent !== null) return Math.max(0, spent)

  const limit = toFiniteNumber(safeBalance.limit)
  const remaining = toFiniteNumber(safeBalance.balance)

  if (limit === null || remaining === null) return 0

  return Math.max(0, limit - remaining)
}

export const formatContractUsage = (balance, formatter = String) => {
  const spent = getSpentAmount(balance)

  if (balance?.limit === null) {
    return `${formatter(spent)} de ∞`
  }

  const limit = toFiniteNumber(balance?.limit)
  if (limit === null) return ""

  return `${formatter(spent)} de ${formatter(limit)}`
}
